<template>
  <svg :width="size" :height="size" :viewBox="viewBox" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path d="M 0 9.601562 C 0 7.839844 1.441406 6.398438 3.199219 6.398438 L 28.800781 6.398438 C 30.566406 6.398438 32 7.832031 32 9.601562 L 32 22.398438 C 32 24.167969 30.566406 25.601562 28.800781 25.601562 L 3.199219 25.601562 C 1.433594 25.601562 0 24.167969 0 22.398438 Z M 3.199219 9.601562 L 3.199219 12.800781 L 6.398438 12.800781 L 6.398438 9.601562 Z M 4.800781 14.398438 L 4.800781 17.601562 L 8 17.601562 L 8 14.398438 Z M 3.199219 19.199219 L 3.199219 22.398438 L 6.398438 22.398438 L 6.398438 19.199219 Z M 8 19.199219 L 8 22.398438 L 24 22.398438 L 24 19.199219 Z M 25.601562 19.199219 L 25.601562 22.398438 L 28.800781 22.398438 L 28.800781 19.199219 Z M 9.601562 14.398438 L 9.601562 17.601562 L 12.800781 17.601562 L 12.800781 14.398438 Z M 14.398438 14.398438 L 14.398438 17.601562 L 17.601562 17.601562 L 17.601562 14.398438 Z M 19.199219 14.398438 L 19.199219 17.601562 L 22.398438 17.601562 L 22.398438 14.398438 Z M 24 14.398438 L 24 17.601562 L 27.199219 17.601562 L 27.199219 14.398438 Z M 8 9.601562 L 8 12.800781 L 11.199219 12.800781 L 11.199219 9.601562 Z M 12.800781 9.601562 L 12.800781 12.800781 L 16 12.800781 L 16 9.601562 Z M 17.601562 9.601562 L 17.601562 12.800781 L 20.800781 12.800781 L 20.800781 9.601562 Z M 22.398438 9.601562 L 22.398438 12.800781 L 28.800781 12.800781 L 28.800781 9.601562 Z M 22.398438 9.601562 "/>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: [Number, String],
      default: 32
    },
    box: {
      type: [Number, String],
      default: 32
    }
  },
  computed: {
    viewBox() {
      return `0 0 ${this.box} ${this.box}`
    }
  }
}
</script>